import { encodeAbiParameters, keccak256, type Hex } from 'viem';
import type { RunnerState } from './types.js';

export const RUNNER_STATE_COMPONENTS = [
  { name: 'x', type: 'int32' },
  { name: 'y', type: 'uint32' },
  { name: 'vx', type: 'int32' },
  { name: 'pressure', type: 'int32' },
  { name: 'route', type: 'uint8' },
  { name: 'inSplit', type: 'bool' },
  { name: 'slowPct', type: 'uint8' },
  { name: 'slowSteps', type: 'uint8' },
  { name: 'overheatSteps', type: 'uint8' },
  { name: 'stumbleUntilY', type: 'uint32' },
] as const;

/** keccak256(abi.encode(RunnerState)) — the per-step commitment stored by RunnerGame. */
export function stateHash(s: RunnerState): Hex {
  return keccak256(
    encodeAbiParameters(
      [{ type: 'tuple', components: RUNNER_STATE_COMPONENTS }],
      [
        {
          x: Number(s.x),
          y: Number(s.y),
          vx: Number(s.vx),
          pressure: Number(s.pressure),
          route: s.route,
          inSplit: s.inSplit,
          slowPct: Number(s.slowPct),
          slowSteps: Number(s.slowSteps),
          overheatSteps: Number(s.overheatSteps),
          stumbleUntilY: Number(s.stumbleUntilY),
        },
      ],
    ),
  );
}
